import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { IdentificationDocumentRemindersSectionContent } from "web_myplann/Reminders/Components/IdentificationDocumentRemindersSectionContent";
import { PortfolioRemindersSectionContent } from "web_myplann/Reminders/Components/PortfolioRemindersSectionContent";
import { PropertyRemindersSectionContent } from "web_myplann/Reminders/Components/PropertyRemindersSectionContent";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
};

export const RemindersSectionContent = ({ entity }: Props) => {
	switch (entity.type) {
		case ReminderEntityTypeEnum.Portfolio:
			return <PortfolioRemindersSectionContent entity={entity} />;
		case ReminderEntityTypeEnum.IdentificationDocument:
			return <IdentificationDocumentRemindersSectionContent entity={entity} />;
		default:
			return <PropertyRemindersSectionContent entity={entity} />;
	}
};
